import { isConfigFlagTruthy } from "@/utils/configFlag";

/**
 * `window.rechnerCustomConfig.enable_email_verification` — require email verification
 * for the policy holder: hide the broker opt-out checkbox and always send verification.
 */
export function isEmailVerificationEnforced(): boolean {
  if (typeof window === "undefined") return false;
  const cfg = window.rechnerCustomConfig;
  if (!cfg) return false;
  return isConfigFlagTruthy(cfg.enable_email_verification);
}

export function enforceEmailVerificationInPolicyHolder(
  policyHolder: Record<string, unknown> | null | undefined,
): void {
  if (!isEmailVerificationEnforced() || !policyHolder) return;
  policyHolder.verification_not_required = false;
}
